import axios from "axios";
import {
  server,
  apiUrlImmigration,
  NOT_CONNECT_NETWORK,
  NETWORK_CONNECTION_MESSAGE,
} from "@/services/constants";
import router from "@/router";
import api from "@/services/api";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

const httpClientImmigration = axios.create({
  baseURL: apiUrlImmigration,
});

httpClientImmigration.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    const userToken = localStorage.getItem(server.TOKEN_KEY);
    if (userToken) {
      config.headers = {
        "x-access-token": userToken,
        authorization: `Bearer ${userToken}`,
      };
    }
    config.url = apiUrlImmigration + "/" + config.url;
    console.log("httpClientImmigration:" + config.url);
  }
  config.timeout = 120000;
  return config;
});

httpClientImmigration.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else if (!error.response) {
      return Promise.reject({
        code: NOT_CONNECT_NETWORK,
        message: NETWORK_CONNECTION_MESSAGE,
      });
    }
    const { response } = error;
    if (response.status === 401) {
      api.logoff();
      router.push("/login").catch(() => {});
    } else {
      router.push("/");
    }
    return Promise.reject(error);
  },
);

export default httpClientImmigration;
